export const RESOURCE_TYPE = {
  ACHIEVEMENTS: "achievements",
  BADGES: "badges",
  CATEGORIES: "categories",
  CATEGORY_VIDEOS: "categoryVideos",
  CHALLENGES: "challenges",
  CLASSES: "classes",
  CLASS_LEVELS: "classLevels",
  CLASS_STYLES: "classStyles",
  CLASS_TRACKS: "classTracks",
  CLASS_TYPES: "classTypes",
  CLASS_VIDEOS: "classVideos",
  COUNTRIES: "countries",
  ENUMS: "enums",
  FEATURED: "featured",
  FLAGGED_ACTIVITY: "flaggedActivity",
  INSTRUCTORS: "instructors",
  INSTRUCTOR_CREDITS: "instructorCredits",
  PLANS: "plans",
  PLAYLISTS: "playlists",
  ROLES: "roles",
  TAGS: "tags",
  TAG_TYPES: "tagTypes",
  TRACKS: "tracks",
  TRACK_ARTISTS: "trackArtists",
  TRACK_GENRES: "trackGenres",
  USERS: "users",
  PROGRAMS: "programs",
  VIDEO_UPLOADS: "videoUploads",
};
